import type { LabelWithScore } from '@core/components/LabelWithScoreThresholdSelector';
import type { LabelWithSeverity } from '@core/components/LabelWithSeveritySelector';
import type { DomainError } from '@core/domain';

/**
 * Dialog step enumeration
 */
export enum DialogStep {
  POLICY_INFO = 'policy-info',
  TEXT_LABELS = 'text-labels',
  IMAGE_LABELS = 'image-labels',
  REVIEW = 'review',
}

/**
 * Policy information step data (Step 1)
 */
export interface DialogPolicyInfo {
  name: string;
  description: string;
  isEnabled: boolean;
}

/**
 * Text labels step data (Step 2)
 */
export interface DialogTextLabels {
  textLabels: LabelWithSeverity[];
}

/**
 * Image labels step data (Step 3)
 */
export interface DialogImageLabels {
  imageLabels: LabelWithScore[];
}

/**
 * Review step data (Step 4)
 */
export interface DialogReview {
  isValid: boolean;
  warnings: string[];
}

/**
 * Complete dialog form data
 */
export interface DialogFormData {
  policyInfo: DialogPolicyInfo;
  textLabels: DialogTextLabels;
  imageLabels: DialogImageLabels;
  review: DialogReview;
}

/**
 * Dialog state interface
 */
export interface DialogState {
  currentStep: DialogStep;
  formData: DialogFormData;
  isValid: boolean;
  isSubmitting: boolean;
  errors: DomainError[];
}
